import { useTranslation } from "react-i18next";

export default function ProcessSection() {
  const { t } = useTranslation();

  const steps = [
    {
      step: t("process.step1"),
      title: t("process.step1Title"),
      description: t("process.step1Desc"),
    },
    {
      step: t("process.step2"),
      title: t("process.step2Title"),
      description: t("process.step2Desc"),
    },
    {
      step: t("process.step3"),
      title: t("process.step3Title"),
      description: t("process.step3Desc"),
    },
    {
      step: t("process.step4"),
      title: t("process.step4Title"),
      description: t("process.step4Desc"),
    },
  ];

  return (
    <section id="how-it-works" className="w-full bg-paper-secondary py-20 md:py-28 scroll-mt-20">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl mb-10 md:mb-14">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold mb-4">
            {t("process.sectionLabel")}
          </p>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-[2.75rem] text-ink leading-[1.1] mb-5">
            {t("process.title")}
            <br />
            <span className="italic font-normal text-ink/70">{t("process.titleItalic")}</span>
          </h2>
          <p className="text-base text-ink/50 leading-relaxed max-w-xl font-light">
            {t("process.intro")}
          </p>
        </div>

        <div className="mb-12 md:mb-16 overflow-hidden border border-hairline">
          <img
            src="https://readdy.ai/api/search-image?query=Sunlight%20falling%20across%20a%20traditional%20Japanese%20tatami%20room%20with%20shoji%20screens%20and%20wooden%20beams%20serene%20empty%20space%20warm%20golden%20tones%20soft%20film%20grain%20editorial%20interior%20photography%20no%20people%20no%20on-image%20text%20no%20logos&width=1200&height=500&seq=noren-process-tatami&orientation=landscape"
            alt="Sunlight falling across a traditional Japanese tatami room with shoji screens, serene and empty"
            loading="lazy"
            className="w-full h-56 md:h-72 object-cover"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {steps.map((s) => (
            <div
              key={s.step}
              className="bg-paper border border-hairline p-6 md:p-8 hover:-translate-y-1 transition-transform duration-300"
            >
              <span className="font-serif text-4xl md:text-5xl text-gold/30 font-semibold block mb-4">
                {s.step}
              </span>
              <h3 className="text-lg font-semibold text-ink mb-3">
                {s.title}
              </h3>
              <p className="text-sm text-ink/50 leading-relaxed font-light">
                {s.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}